module.exports = __webpack_public_path__ + "img/Memberkit-4-pt.ad1dec79.png";